import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Card,
  Button,
  Tag,
  Carousel,
  Modal,
  Form,
  Input,
  Space,
  Spin,
  Checkbox,
  message,
  Grid,
  Tooltip,
} from "antd";
import ReactCardFlip from "react-card-flip";
import no_image from "../assets/images/no_image.png";
import whatsapp from "../assets/images/whatsapp.svg";
import googleMap from "../assets/images/googleMap.svg";
import backIcon from "../assets/images/backIcon.svg";
import call from "../assets/images/ion_call.svg";
import "../components/propertycard.css";
import { Controller, useForm } from "react-hook-form";
import TextArea from "antd/es/input/TextArea";
import { createEnquiry } from "../Actions/enquiryAction";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useBreakpoints } from "./ResponsiveBreakPoints";
import { DownloadOutlined, RetweetOutlined, InfoCircleOutlined } from "@ant-design/icons";

const ProjectCard = ({ project, openEnquiryModal }) => {
  const {
    images,
    builder,
    bhk,
    price_range,
    property_name,
    area_name,
    description,
    price,
    google_link,
    possesion,
    no_of_floor,
    total_units,
  } = project;

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isXSOnly = screens.xs && !screens.sm;

  const schema = Yup.object().shape({
    full_name: Yup.string().required("Required"),
    phone: Yup.string().required("Required"),
  });

  const { Text, Title } = Typography;
  const dispatch = useDispatch();
  const { isCreateEnquiryLoading } = useSelector((state) => state.enquiries);

  const [isFlipped, setIsFlipped] = useState(false);
  const [cardHeight, setCardHeight] = useState(null);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [termsAgreed, setTermsAgreed] = useState({
    isChecked: false,
    message: null,
  });
  const frontRef = useRef(null);

  const { register, handleSubmit, errors, control, reset } = useForm({
    defaultValues: {
      full_name: "",
      email: "",
      phone: "",
      comments: "",
    },
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (frontRef.current) {
      setCardHeight(frontRef.current.offsetHeight);
    }
  }, [project, isFlipped]);

  const image =
    images && images.length > 0 ? images[0].image_url?.url : no_image;

  const openWhatsApp = () => {
    const number = process.env.REACT_APP_WHATSAPP_NUMBER;
    const message = `Hi! I'm interested in the property "${property_name}". Please share more details.`;

    const encoded = encodeURIComponent(message);

    window.open(`https://wa.me/${number}?text=${encoded}`, "_blank");
  };

  const openCall = () => {
    const phoneNumber = process.env.REACT_APP_PHONE_NUMBER;
    if (phoneNumber) {
      window.open(`tel:${phoneNumber}`);
    }
  };

  const openDiscussModel = () => {
    openEnquiryModal(project);
  };
  const downloadBrochure = async () => {
    const filePath = project?.project_pdf?.file?.url;
    const baseUrl =
      process.env.REACT_APP_API_BASE_URL || "https://api.svmdproperty.com";

    if (!filePath) {
      message.warning("Brochure not available for this project");
      return;
    }

    try {
      const response = await fetch(`${baseUrl}${filePath}`, { method: "GET" });

      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${project.property_name || "brochure"}.pdf`;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error("Unable to download brochure");
    }
  };

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  return (
    <>
      <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
        {/* ---------------- FRONT ---------------- */}
        <Card
          bodyStyle={{ padding: 0 }}
          ref={frontRef}
          style={{
            boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
          }}
        >
          <Row gutter={0}>
            {/* Left side image / carousel */}
            <Col xs={24} sm={12} style={{ padding: 10 }}>
              <div className="imageWrapper">
                <Carousel autoplay dots={images?.length > 1}>
                  {Array.isArray(images) && images.length > 0 ? (
                    images.map((img, idx) => (
                      <div key={idx}>
                        <img
                          alt={`project-${idx}`}
                          src={img.image_url?.url || no_image}
                          style={{
                            width: "100%",
                            height: isXSOnly? "320px":"250px",
                            objectFit: "cover",
                            borderRadius: 8,
                          }}
                        />
                      </div>
                    ))
                  ) : (
                    <div>
                      <img
                        alt="no_image"
                        src={no_image}
                        style={{
                          width: "100%",
                          height: isXSOnly? "320px":"250px",
                          objectFit: "cover",
                          borderRadius: 8,
                        }}
                      />
                    </div>
                  )}
                </Carousel>
              </div>
            </Col>

            {/* Right side details */}
            <Col
              xs={24}
              sm={12}
              style={{
                padding: 10,
                paddingLeft: isXSOnly ? 10 : 4,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Row align="middle" wrap={false}>
                <Col flex="auto">
                  <Typography className="typography1">
                    {property_name}
                  </Typography>
                </Col>

                <Col flex="none">
                  <Button
                    onClick={() => setIsFlipped(true)}
                    className="checkDetailsButton2"
                    style={{marginLeft:'4px'}}
                  >
                    Check details
                  </Button>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Row gutter={[0, 5]}>
                    {bhk && (
                      <Col span={24}>
                        <Typography className="projectDetailsText">
                          {bhk}
                        </Typography>
                      </Col>
                    )}

                    {area_name && (
                      <Col span={24}>
                        <Typography className="projectDetailsText">
                          <FaMapMarkerAlt size={12} /> {area_name}
                        </Typography>
                      </Col>
                    )}

                    {(price_range || possesion) && (
                      <Col span={24}>
                        <Row
                          style={{
                            borderTop: "1px solid #e6e6e6",
                            borderBottom: "1px solid #e6e6e6",
                            // borderRadius: 10,
                            padding: "10px 0px",
                            marginTop: 8,
                            marginBottom: isXSOnly ? 8 : 0,
                          }}
                          // gutter={16}
                        >
                          <Col span={12}>
                            <Typography style={{ fontSize: 12, color: "#777" }}>
                              Price Range
                            </Typography>
                            <span className="premium-price-wrapper">
                              <span className="premium-price">₹{price_range || "0 - 0"}</span>
                              <Tooltip
                                title={<span className="premium-tooltip-text">Basic Price only</span>}
                                trigger="hover"
                                placement="top"
                                overlayClassName="premium-price-tooltip"
                              >
                                <InfoCircleOutlined
                                  className="premium-price-info-icon"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                />
                              </Tooltip>
                            </span>
                          </Col>

                          {possesion && (
                            <Col
                              span={12}
                              style={{
                                borderLeft: price_range
                                  ? "1px solid #eee"
                                  : "none",
                                paddingLeft: price_range ? 12 : 0,
                              }}
                            >
                              <Typography
                                style={{ fontSize: 12, color: "#777" }}
                              >
                                Possession
                              </Typography>
                              <Typography style={{ fontWeight: 600 }}>
                                {possesion}
                              </Typography>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col span={14}>
                  {builder && (
                    <Col span={24}>
                      <Typography
                        className="projectDetailsText"
                        style={{ fontSize: "13px" }}
                      >
                        By {builder}
                      </Typography>
                    </Col>
                  )}
                </Col>
                <Col
                  span={24}
                  style={{
                    marginTop: 8,
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                  }}
                >
                  <Button
                    onClick={() => openDiscussModel(true)}
                    className="checkDetailsButton"
                  >
                    {project?.project_pdf?.file?.url
                      ? "Download Brochure"
                      : "Get Offer"}
                  </Button>
                  {/* {project?.project_pdf?.file?.url && (
                    <Tooltip title="Download brochure">
                      <DownloadOutlined
                        onClick={downloadBrochure}
                        style={{ fontSize: 20 }}
                        className="actionIcon"
                      />
                    </Tooltip>
                  )} */}
                  <Tooltip title="Chat on WhatsApp">
                    <img
                      src={whatsapp}
                      alt="Whatsapp"
                      className="actionIcon"
                      onClick={openWhatsApp}
                    />
                  </Tooltip>

                  {/* <Tooltip title="Call now">
                    <img
                      src={call}
                      alt="call"
                      className="actionIcon"
                      onClick={openCall}
                    />
                  </Tooltip> */}
                  {isValidUrl(google_link) && (
                    <Tooltip title="Location">
                      <img
                        src={googleMap}
                        alt="Google Map"
                        className="actionIcon"
                        onClick={() => window.open(google_link, "_blank")}
                      />
                    </Tooltip>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>

        {/* ---------------- BACK ---------------- */}
        <Card
          style={{
            background: "#1c3988",
            color: "white",
            height: cardHeight || "auto",
            position: "relative", // <--- required for absolute children
            overflow: "hidden",
          }}
          bodyStyle={{ padding: 16 }}
        >
          {/* main content area (left/top tags) */}
          <div className="backContent">
            <Row gutter={[8, 12]}>
              <Col
                span={24}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={backIcon}
                    alt="back"
                    style={{ cursor: "pointer", marginRight: 8 }}
                    onClick={() => setIsFlipped(false)}
                  />
                  <Typography className="projectDeatilsTitle">
                    Project Details
                  </Typography>
                </div>
                <RetweetOutlined
                  style={{ fontSize: 20, cursor: "pointer", color: "white" }}
                  onClick={() => setIsFlipped(false)}
                />
              </Col>

              <Col span={24}>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    marginBottom: "8px",
                  }}
                >
                  {description?.description
                    ?.filter((d) => d.key?.trim() && d.value?.trim())
                    .map((d, i) => (
                      <Typography className="projectTextDetails" key={i}>
                        {d.key}: {d.value}
                      </Typography>
                    ))}

                  {/* other tags if any will flow/wrap here */}
                </div>
              </Col>
            </Row>
          </div>

          {/* bottom-right pinned storey & units */}
          <div className="bottomRightDetails">
            {no_of_floor !== null &&
              no_of_floor !== undefined &&
              no_of_floor !== 0 &&
              no_of_floor !== "0" && (
                <div className="projectTextDetails">Storey: {no_of_floor}</div>
              )}
            {total_units && (
              <div className="projectTextDetails">Units: {total_units}</div>
            )}
          </div>
        </Card>
      </ReactCardFlip>
    </>
  );
};

export default ProjectCard;
